export default "__VITE_ASSET__CyDT6nhQ__"